// File: src/components/Hero.jsx
import heroImage from '../assets/robot4.png';
import { lang } from '../lang/lang';
import { FaRobot, FaComments, FaBrain, FaChartBar } from 'react-icons/fa';

const iconMap = {
  robot: <FaRobot />,
  comments: <FaComments />,
  brain: <FaBrain />,
  chart: <FaChartBar />
};

const iconColors = [
    'text-[#8B5CF6]',  // Morado
    'text-[#2BA79D]', // Verde JRautomation
    'text-[#1B2D44]', // Azul oscuro JRautomation
    'text-[#F59E0B]' // Amarillo suave
];

const Hero = ({ language }) => {
  const t = lang[language];

  return (
    <section className="bg-gradient-to-b from-white via-sky-50 to-sky-100 py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center">
        {/* Text Side */}
        <div>
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1B2D44] mb-4">
            {t.heroTitle}
          </h1>
          <p className="text-gray-600 mb-6 text-lg">{t.heroSubtitle}</p>
          <a
            href="https://cal.com/jrautomation/consultation"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-6 py-3 bg-[#2BA79D] text-white rounded-lg shadow hover:bg-[#23877F] transition hover:animate-bounce"
          >
            {t.bookDemo}
          </a>
        </div>

        {/* Image Side */}
        <div className="flex justify-center">
          <img
            src={heroImage}
            alt="Hero Illustration"
            className="w-3/4 max-w-sm"// animate-bounce
          />
        </div>
      </div>

      {/* Benefit Icons */}
      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto">
        {t.benefits.map((item, index) => (
          <div key={index} className="flex flex-col items-center text-center">
            <div className={`text-5xl mb-3 ${iconColors[index % iconColors.length]}`}>
              {iconMap[item.icon]}
            </div>
            <p className="text-gray-700 text-sm">{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Hero;

